function Column_list(element) {
  this.$element = $(element);

  this.init = function () {

    this.initSort();
  };

  this.initSort = function() {
    i4_Sort.factory(this.$element, 'js=Column').
    set_handles('js-sort-handle').
    set_send_type('list').
    set_constraint('vertical').
    run();
  };
}
